/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AlertType } from 'models/viewModels';

export const alertTypesToFormattedNames: Record<AlertType, string> = {
  [AlertType.AUDIO]: 'Keyword Detection',
  [AlertType.FLAG]: 'Flag Change',
  [AlertType.PIT]: 'Pit Activity',
  [AlertType.LUCKYDOG]: 'Lucky Dog',
  [AlertType.UNKNOWN]: 'Unknown',
};

export const getFormattedAlertType = (alertType: AlertType) => {
  return alertTypesToFormattedNames[alertType];
};

export const getAlertTypeFromFormattedName = (formattedName: string) => {
  const alertTypeEntry = Object.entries(alertTypesToFormattedNames).find(([, name]) => name === formattedName);
  if (alertTypeEntry) {
    return Number(alertTypeEntry[0]) as AlertType;
  }
  return undefined;
};

export const defaultAlertCategoriesFiltered = Object.values(alertTypesToFormattedNames).reduce(
  (accumulator, category) => {
    accumulator[category] = true;
    return accumulator;
  },
  {} as Record<string, boolean>
);
